<script setup>
import {Head, Link, useForm, usePage} from "@inertiajs/inertia-vue3";
import InputText from "primevue/inputtext";
import Button from "primevue/button";
import {computed} from "vue";
import Checkbox from "primevue/checkbox";
import Layout from '../Layouts/Guest.vue';

const props = defineProps([
    'flash',
]);

const form = useForm({
    email: "",
    password: "",
    remember: false,
});

const errors = computed(() => usePage().props.value.errors);
const submit = () => {
    /****
    Inertia.post(route("login"), unref(form), {
        preserveScroll: true,
        onError: (errors) => {
            console.log(errors);
        },
        onSuccess: () => {},
    });
    ****/

    form.post(route("login"), {
        preserveScroll: true,
        onError: (errors) => {
            console.log(errors);
            //form.reset("password");
        },
        onFinish: () => form.reset("password"),
    });
};
</script>

<template>
    <Head title="Login" />

    <Layout :flash="flash">
        <div class="flex-1 max-w-[350px]">
            <form @submit.prevent="submit">
                <div class="my-4">
                    <label class="p-1 text-sm">Email</label>
                    <InputText
                        type="email"
                        v-model="form.email"
                        :class="`w-full ${form.errors.email ? 'border-red-500' : ''}`"
                    />

                    <small v-if="form.errors.email" class="text-error">
                        {{ form.errors.email[0] }}
                    </small>
                </div>
                
                <div class="my-4">
                    <label class="p-1 text-sm">Passwort</label>
                    <InputText
                        type="password"
                        v-model="form.password"
                        class="w-full"
                    />
                </div>
                <div class="my-4 flex items-center gap-2">
                    <Checkbox
                        v-model="form.remember"
                        inputId="remember-me"
                        binary
                    />
                    <label for="remember-me" class="p-1 text-sm cursor-pointer">angemeldet bleiben</label>
                </div>

                <div class="my-5">
                    <Button
                        type="submit"
                        label="Einloggen"
                        :disabled="form.processing"
                        class="w-full bg-[#FFF053] text-black border-none"
                    />
                </div>
                <div class="my-4 text-sm text-center">
                    <Link href="/forgot-password">Passwort vergessen?</Link>
                </div>
            </form>
        </div>
    </Layout>
</template>
